import React, { Component } from "react";
import ReactPlayer from "react-player";

import style from "./responsive-player.module.scss";

export default class ResponsivePlayer extends Component {
  render() {
    return (
      <div className={style["player-wrapper"]}>
        <ReactPlayer className={style["react-player"]} width="100%" height="100%" {...this.props} />
      </div>
    );
  }
}
